import { render, staticRenderFns } from "./AAnniversaryEventWidget.vue?vue&type=template&id=2a3f4dee&"
import script from "./AAnniversaryEventWidget.vue?vue&type=script&lang=ts&"
export * from "./AAnniversaryEventWidget.vue?vue&type=script&lang=ts&"
import style0 from "./AAnniversaryEventWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBadge,VBtn,VIcon,VListItem,VListItemAction,VListItemContent,VListItemTitle})
